import { Link } from "react-router-dom";
import { BRAND } from "@/config/brand";

// Light footer that matches the Webflow theme footer on home / how-it-works / rates
// so React-served pages (blog, contact, legal, dashboard, etc.) look consistent
// with the rest of the site.
export default function Footer() {
  return (
    <footer className="footer-wrapper" style={{ backgroundColor: "#FFFAF0", color: "#353564" }}>
      <div className="w-layout-blockcontainer container-default w-container" style={{ maxWidth: 1240, margin: "0 auto", padding: "0 24px" }}>
        {/* CTA card */}
        <div
          className="card content-top-footer"
          style={{
            textAlign: "center",
            padding: "clamp(60px, 8vw, 100px) clamp(24px, 4vw, 40px)",
            display: "block",
            background: "#353564",
            borderRadius: 32,
            marginTop: 40,
          }}
        >
          <div style={{ maxWidth: 1100, margin: "0 auto" }}>
            <h2
              style={{
                color: "#fff",
                fontSize: "clamp(32px, 5.5vw, 72px)",
                lineHeight: 1.05,
                margin: "0 0 32px 0",
                letterSpacing: "-0.02em",
                fontWeight: 800,
              }}
            >
              Ready to turn unused gift cards into cash?
            </h2>
            <div style={{ display: "flex", justifyContent: "center", gap: 40, flexWrap: "wrap", margin: "0 0 44px 0" }}>
              <div style={{ color: "#D2F1A9", fontWeight: 600, fontSize: 17 }}>Secure verification.</div>
              <div style={{ color: "#D2F1A9", fontWeight: 600, fontSize: 17 }}>Competitive offers.</div>
              <div style={{ color: "#D2F1A9", fontWeight: 600, fontSize: 17 }}>Dedicated support.</div>
            </div>
            <Link
              to="/submit"
              className="primary-button w-inline-block"
              style={{ padding: "22px 56px", fontSize: 18, display: "inline-block", background: "#636AC3", color: "#fff", borderRadius: 999, textDecoration: "none", fontWeight: 700 }}
            >
              Get Started
            </Link>
          </div>
        </div>

        {/* Link grid */}
        <div style={{ padding: "80px 0 60px 0" }}>
          <div
            className="footer-middle-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
              gap: 60,
              alignItems: "start",
            }}
          >
            {/* Brand */}
            <div>
              <div style={{ marginBottom: 20 }}>
                <img
                  src="/site/images/nexon-logo.webp"
                  alt="GC Nexon"
                  style={{ height: 60, width: "auto", objectFit: "contain", display: "block" }}
                />
              </div>
              <p style={{ color: "#5A5A7A", lineHeight: 1.6, fontSize: 15, margin: "0 0 26px 0", maxWidth: 360 }}>
                Sell your unused gift cards for cash. Same-day payouts, competitive rates, and support you can count on.
              </p>
              <Link
                to="/submit"
                className="primary-button w-inline-block"
                style={{ display: "inline-block", background: "#636AC3", color: "#fff", padding: "14px 28px", borderRadius: 999, textDecoration: "none", fontWeight: 700, fontSize: 15 }}
              >
                Sell gift card
              </Link>
            </div>

            {/* Explore */}
            <div>
              <div style={{ fontWeight: 800, marginBottom: 20, fontSize: 18, color: "#353564" }}>Explore</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 14, fontSize: 15 }}>
                <Link to="/how-it-works" style={footLink}>How it works</Link>
                <Link to="/rates" style={footLink}>Live rates</Link>
                <Link to="/accepted-cards" style={footLink}>Brands we buy</Link>
                <Link to="/blog" style={footLink}>Blog</Link>
                <Link to="/about" style={footLink}>About us</Link>
              </div>
            </div>

            {/* Support */}
            <div>
              <div style={{ fontWeight: 800, marginBottom: 20, fontSize: 18, color: "#353564" }}>Support</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 14, fontSize: 15 }}>
                <Link to="/track" style={footLink}>Track my order</Link>
                <Link to="/faq" style={footLink}>FAQ</Link>
                <Link to="/contact" style={footLink}>Contact us</Link>
                <Link to="/legal/privacy" style={footLink}>Privacy</Link>
                <Link to="/legal/terms" style={footLink}>Terms</Link>
              </div>
            </div>

            {/* Get in touch */}
            <div>
              <div style={{ fontWeight: 800, marginBottom: 20, fontSize: 18, color: "#353564" }}>Get in touch</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 14, fontSize: 15 }}>
                <a href={`mailto:${BRAND.email}`} style={footLink}>{BRAND.email}</a>
                <div style={{ color: "#5A5A7A", lineHeight: 1.6 }}>
                  1013 Centre Rd<br />Wilmington, DE 19805
                </div>
                <div style={{ color: "#8888A5", fontSize: 13 }}>Mon–Sat, 9am–8pm ET</div>
              </div>
              <div style={{ marginTop: 22, display: "flex", gap: 10 }}>
                <SocialIcon href="#" label="Twitter">
                  <path d="M22 5.8a8.5 8.5 0 0 1-2.4.7 4.2 4.2 0 0 0 1.8-2.3 8.4 8.4 0 0 1-2.6 1 4.2 4.2 0 0 0-7.1 3.8A11.9 11.9 0 0 1 3 4.7a4.2 4.2 0 0 0 1.3 5.6c-.7 0-1.4-.2-2-.5v.1a4.2 4.2 0 0 0 3.3 4.1 4.2 4.2 0 0 1-1.9.1 4.2 4.2 0 0 0 3.9 2.9A8.4 8.4 0 0 1 2 18.6a11.8 11.8 0 0 0 6.4 1.9c7.7 0 11.9-6.4 11.9-11.9V8a8.5 8.5 0 0 0 2.1-2.2z" />
                </SocialIcon>
                <SocialIcon href="#" label="Facebook">
                  <path d="M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H8V12h2.4V9.8c0-2.4 1.4-3.7 3.6-3.7 1 0 2.1.2 2.1.2v2.3h-1.2c-1.2 0-1.5.7-1.5 1.5V12h2.6l-.4 2.9h-2.1V22C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z" />
                </SocialIcon>
                <SocialIcon href="#" label="Instagram">
                  <path d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 1.9.3 2.3.4.6.2 1 .5 1.4.9.4.4.7.9.9 1.4.2.4.4 1.1.4 2.3.1 1.3.1 1.7.1 4.8s0 3.6-.1 4.8c-.1 1.2-.3 1.9-.4 2.3-.2.6-.5 1-.9 1.4-.4.4-.9.7-1.4.9-.4.2-1.1.4-2.3.4-1.3.1-1.7.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-1.9-.3-2.3-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.9-.9-1.4-.2-.4-.4-1.1-.4-2.3-.1-1.3-.1-1.7-.1-4.8s0-3.6.1-4.8c.1-1.2.3-1.9.4-2.3.2-.6.5-1 .9-1.4.4-.4.9-.7 1.4-.9.4-.2 1.1-.4 2.3-.4 1.3-.1 1.7-.1 4.8-.1zm0 4.9a4.9 4.9 0 1 0 0 9.8 4.9 4.9 0 0 0 0-9.8zm0 8a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm5.1-8.2a1.1 1.1 0 1 0 0-2.3 1.1 1.1 0 0 0 0 2.3z" />
                </SocialIcon>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div
          style={{
            padding: "24px 0",
            borderTop: "1px solid rgba(53,53,100,0.08)",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            fontSize: 13,
            color: "#8888A5",
          }}
        >
          <div>© {new Date().getFullYear()} {BRAND.name} · All rights reserved</div>
          <div>Payments in USD. Not affiliated with any brand listed.</div>
        </div>
      </div>

      {/* Responsive grid — stack on mobile */}
      <style>{`
        @media (max-width: 900px) {
          .footer-middle-grid { grid-template-columns: 1fr 1fr !important; gap: 40px !important; }
        }
        @media (max-width: 560px) {
          .footer-middle-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
      `}</style>
    </footer>
  );
}

const footLink = {
  color: "#5A5A7A",
  textDecoration: "none",
  transition: "color .15s ease",
};

function SocialIcon({ href, label, children }) {
  return (
    <a
      href={href}
      aria-label={label}
      style={{
        width: 38,
        height: 38,
        borderRadius: "50%",
        background: "#fff",
        border: "1px solid #E5E5EE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#636AC3",
      }}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        {children}
      </svg>
    </a>
  );
}
